import Input from "components/input";
import Select from "components/select";
import { DriverFormValues } from "_interfaces/driver.interfaces";
import { NamespaceKeys } from "locale/types";
import { Controller, UseFormReturn } from "react-hook-form";
import DriverAccordion from "./driver-accordion";

interface DriverAccountAccessAccordionProps {
  isOpen: boolean;
  onToggle: () => void;
  form: UseFormReturn<DriverFormValues>;
  t: (key: NamespaceKeys<"driver">, options?: Record<string, unknown>) => string;
}

const DriverAccountAccessAccordion = ({
  isOpen,
  onToggle,
  form,
  t,
}: DriverAccountAccessAccordionProps) => {
  const {
    register,
    watch,
    formState: { errors },
  } = form;

  const creationMethod = watch("creationMethod");

  return (
    <DriverAccordion
      title={t("accordion-account-access")}
      subtitle={t("accordion-account-access-subtitle")}
      iconName="login"
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <div className="grid grid-cols-2 gap-4">
        <Input
          label={t("label-driver-email")}
          required
          placeholder={t("placeholder-driver-email")}
          data-testid="input-driver-email"
          {...register("email")}
          error={errors.email}
        />

        <Controller
          name="creationMethod"
          control={form.control}
          render={({ field, fieldState }) => (
            <Select
              label={t("label-creation-method")}
              required
              data-testid="select-creation-method"
              options={[
                { label: t("creation-method-invitation"), value: "invitation" },
                { label: t("creation-method-manual"), value: "manual" },
              ]}
              value={field.value}
              onValueChange={(value) => {
                field.onChange(value);
                if (value === "invitation") {
                  form.setValue("password", "");
                }
              }}
              error={fieldState.error}
              placeholder={t("placeholder-select")}
            />
          )}
        />

        {creationMethod === "manual" ? (
          <Input
            label={t("label-driver-password")}
            required
            type="password"
            placeholder={t("placeholder-driver-password")}
            data-testid="input-driver-password"
            {...register("password")}
            error={errors.password}
          />
        ) : null}
      </div>
    </DriverAccordion>
  );
};

export default DriverAccountAccessAccordion;
